import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import FooterContainer from '../../components/FooterContainer/FooterContainer';
import Button from '../../elements/Button/Button';
import { Image, HeadWrapper } from '../../elements';
import { setFlag } from '../../redux/flags/flags';
import './About.scss';
import { ReactComponent as ArrowTeam } from '../../styles/icon/arrow-team.svg';
import story_1 from '../../styles/images/about/img-story.jpeg';
import story_1x2 from '../../styles/images/about/img-story@2x.jpeg';
import img_slide_1 from '../../styles/images/about/img-slide-1.jpeg';
import img_slide_1x2 from '../../styles/images/about/img-slide-1@2x.jpeg';
import img_slide_2 from '../../styles/images/about/img-slide-2.jpeg';
import img_slide_2x2 from '../../styles/images/about/img-slide-2@2x.jpeg';
import img_slide_3 from '../../styles/images/about/img-slide-3.jpeg';
import img_slide_3x2 from '../../styles/images/about/img-slide-3@2x.jpeg';
import img_slide_4 from '../../styles/images/about/img-slide-4.jpeg';
import img_slide_4x2 from '../../styles/images/about/img-slide-4@2x.jpeg';
import { Swiper, SwiperSlide } from 'swiper/react';
import strings from '../../lang/lang';
// import 'swiper/swiper.scss';

const mapDispatchToProps = {
  setFlag,
};

const About = (props) => {
  const swiperRef = useRef();
  useEffect(() => {
    console.log('swiperRef', swiperRef);
    window.swUpdate = swiperRef?.current;
    props.setFlag('isHeaderAbout', true);
    return () => {
      props.setFlag('isHeaderAbout', false);
    };
  }, []);
  return (
    <div>
      <HeadWrapper
        href="https://developer.staq.io/about"
        title="About Us | Staq  Developer Portal"
        description="Learn about Staq: Our mission, vision, and the innovative technology driving our solutions. Discover how we're shaping the future of digital development."
      />
      <div className="about">
        <a href="https://staq.io/careers/jobs" className="about__link about__link--mobile" target="_blank">
          <Button name={strings.about.text.btnJoin} type="button" variant="gradient_type2">
            <ArrowTeam />
          </Button>
        </a>
        <div className="about__figure-top-left"></div>
        <div className="about__figure-top-right"></div>
        <div className="about__container">
          <div className="about__figure-bottom-left"></div>
          <div className="about__figure-center"></div>
          <div className="about__figure-bottom-right"></div>
          <div className="about__title">
            <h1>
              {strings.about.text.titlePart1} <br /> {strings.about.text.titlePart2}
            </h1>
            <p>
              {strings.about.text.description}
            </p>
          </div>
          <div className="about__wrapper">
            <div className="about__info">
              <h2>{strings.about.text.titleH2}</h2>
              <p>
                {strings.about.text.descriptionInfo}
              </p>
              <a href="https://staq.io/careers/jobs" target="_blank" className="about__link">
                <Button name={strings.about.text.btnJoin} type="button" variant="gradient_type2">
                  <ArrowTeam />
                </Button>
              </a>
            </div>
            <div className="about__slider-wrap">
              <Swiper onSwiper={(c) => swiperRef.current = c} className="about__slider" slidesPerView="auto"
              centeredSlides
              loop
              preloadImages
              spaceBetween={44}
              breakpoints={{
                320: {
                  centeredSlides: false,
                  spaceBetween: 24,
                },
                1024: {
                  centeredSlides: true,
                  spaceBetween: 44,
                },
              }}>
                <SwiperSlide className="about__slide">
                  <Image
                    imgData={{ '1x': img_slide_2, '2x': img_slide_2x2, alt: 'image' }}
                    darkImgData={{ '1x': img_slide_2, '2x': img_slide_2x2, alt: 'image' }}
                  />
                </SwiperSlide>
                <SwiperSlide className="about__slide">
                  <Image
                    imgData={{ '1x': img_slide_3, '2x': img_slide_3x2, alt: 'image' }}
                    darkImgData={{ '1x': img_slide_3, '2x': img_slide_3x2, alt: 'image' }}
                  />
                </SwiperSlide>
                <SwiperSlide className="about__slide">
                  <Image
                    imgData={{ '1x': img_slide_4, '2x': img_slide_4x2, alt: 'image' }}
                    darkImgData={{ '1x': img_slide_4, '2x': img_slide_4x2, alt: 'image' }}
                  />
                </SwiperSlide>
                <SwiperSlide className="about__slide">
                  <Image
                    imgData={{ '1x': img_slide_1, '2x': img_slide_1x2, alt: 'image' }}
                    darkImgData={{ '1x': img_slide_1, '2x': img_slide_1x2, alt: 'image' }}
                  />
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
          <div className="about__story">
            <div className="about__image">
              <Image
                imgData={{ '1x': story_1, '2x': story_1x2, alt: 'Register' }}
                darkImgData={{ '1x': story_1, '2x': story_1x2, alt: 'image' }}
              />
            </div>
            <div className="about__description">
              <div className="about__description-wrap">
                <div className="about__description-box">
                  <h3>{strings.about.text.titleH3}</h3>
                  <p>
                    {strings.about.text.story1}
                  </p>
                  <p>
                  {strings.about.text.story2}
                  </p>
                </div>
                <a href="https://staq.io/careers/jobs" target="_blank" className="about__link">
                  <Button name="Join the team" type="button" variant="gradient_type2">
                    <ArrowTeam />
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="about__wrap">
          <div className="about__box">
            <h2>
            {strings.about.text.titleH2Bank}
            </h2>
            <a href="https://staq.io/careers/jobs" target="_blank" className="about__link">
              <Button name={strings.about.text.btnJoin} type="button" variant="gradient_type2">
                <ArrowTeam />
              </Button>
            </a>
          </div>
        </div>
      </div>
      <FooterContainer />
    </div>
  );
};

export default connect(null, mapDispatchToProps)(About);
